/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckygifts.vue?vue&type=template&id=1942261d&scoped=true"
import script from "./luckygifts.vue?vue&type=script&lang=js"
export * from "./luckygifts.vue?vue&type=script&lang=js"
import style0 from "./luckygifts.vue?vue&type=style&index=0&id=1942261d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1942261d",
  null
  
)

export default component.exports